// extracted by mini-css-extract-plugin
export default {"author":"ActivityItem_author__krE7+","content":"ActivityItem_content__-FsAN","date":"ActivityItem_date__+ShB9","text":"ActivityItem_text__sAtS+","user":"ActivityItem_user__bM88F"};